export const LOANS_APPLICATION = 'md_loans_application_GLOBAL';